import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { TResponseModel } from "../../types/config";
import { ToastOpen, ToastType } from "../../state/toast/slice";
import useToast from "../../hooks/useToast";
import { eResultCode } from "../../utils/enum";
import styles from "./auth.module.css";
import EncryptUtils from "../../utils/encrypt";
import { ChangePassword } from "../../utils/api.constant";

const UpdatePassword: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");

  const onFinish = async (values: {
    newPassword: string;
    confirmPassword: string;
  }) => {
    if (values.newPassword !== values.confirmPassword) {
      onShowToast({
        type: ToastType.error,
        title: "Error",
        position: ToastOpen.centerTop,
        content: "Passwords do not match.",
      });
      return;
    }

    try {
      setIsLoading(true);
      const password = EncryptUtils.encrypt(values.newPassword as string);
      const payload = {
        data: {
          emailId: email,
          password: password,
        },
      };
      const response: TResponseModel = await post(ChangePassword, payload);

      const { dataResponse } = response;
      const { returnCode, description } = dataResponse;

      if (returnCode === eResultCode.SUCCESS) {
        onShowToast({
          type: ToastType.success,
          title: "Success",
          position: ToastOpen.centerTop,
          content: "Password reset successfully.",
        });
        navigate("/login");
      } else {
        onShowToast({
          type: ToastType.error,
          title: "Error",
          position: ToastOpen.centerTop,
          content: description,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.parentWrapper}>
      <Form
        name="resetPassword"
        onFinish={onFinish}
        size="middle"
        autoComplete="off"
      >
        <div className={styles.formHeader}>
          <h1>Reset Password</h1>
        </div>
        <div>
          <p>Enter your new password below to change your password</p>
        </div>
        <Form.Item
          name="newPassword"
          rules={[
            { required: true, message: "Please input your new password!" },
            {
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
              message:
                "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character!",
            },
          ]}
        >
          <Input.Password autoComplete="off" placeholder="New Password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          rules={[
            { required: true, message: "Please confirm your new password!" },
            {
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
              message:
                "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character!",
            },
          ]}
        >
          <Input.Password
            autoComplete="off"
            placeholder="Confirm New Password"
          />
        </Form.Item>
        <Form.Item>
          <Button block type="primary" htmlType="submit" disabled={isLoading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdatePassword;
